export default __webpack_public_path__ + "static/media/logo-blue.5877db64.svg";